<template>
  <div class="compressed-content">
    <h3 class="page-question">Have you ever been told that you have any of the following conditions? <br /> <i>(check all that apply)</i></h3>
    <v-form-group class="card-selector page-buttons" :validator="$v.conditions">
      <b-form-checkbox v-model="survey.medicalConditions.conditions.noConditionTold" @change="onNoConditionSelected">
        No
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.medicalConditions.conditions.hasLVHypertrophy" @change="onLVHypertrophySelected">
        Left ventricular hypertrophy
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.medicalConditions.conditions.hasSleepApnea" @change="onSleepApneaSelected">
        Obstructive sleep apnea
      </b-form-checkbox>
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');
  import { anyOptionRequired } from 'utils/custom-validators';

  export default {
    mixins: [formMixin],

    validations: {
      conditions: {
        anyOptionRequired: anyOptionRequired((value) => value.noConditionTold || value.hasLVHypertrophy || value.hasSleepApnea)
      }
    },

    computed: {
      ...mapState(["survey"]),

      conditions() { return this.survey.medicalConditions.conditions; }
    },

    methods: {
      onNoConditionSelected(value) {
        this.setOptions(value, value ? false : this.conditions.hasLVHypertrophy, value ? false : this.conditions.hasSleepApnea);
      },

      onLVHypertrophySelected(value) {
        this.setOptions(false, value, this.conditions.hasSleepApnea);
      },

      onSleepApneaSelected(value) {
        this.setOptions(false, this.conditions.hasLVHypertrophy, value);
      },

      setOptions(noConditionTold, hasLVHypertrophy, hasSleepApnea) {
        this.survey.medicalConditions.conditions.noConditionTold = noConditionTold;
        this.survey.medicalConditions.conditions.hasLVHypertrophy = hasLVHypertrophy;
        this.survey.medicalConditions.conditions.hasSleepApnea = hasSleepApnea;
      }
    }
  };
</script>